import type { BlogPost } from '../types'

const post: BlogPost = {
  title: 'Competence',
  slug: 'competence',
  category: 'Competence',
  date: '2025-05-16',
  image: '',
  excerpt: 'Perception, Competence, and Confidence',
  body: `Perception, Competence, and Confidence

One of the things I've done in life is record a few albums of originals and covers. When I recorded my first album, my producer told me something that helps me in many other areas.

Before going to the studio to record, focus on every note, every beat. Learn it inside and out. Be hard on yourself. Drill those songs into your soul.

Then go into the studio, forget everything you just learned, and just play.

And here's a piece of wisdom from the poker table: if you can't spot the sucker, it's you.

There are four stages of learning. Put another way, four perceptions of competence:

**1. Unconscious Incompetence.** I don't know what I don't know. I don't perceive my limitations and I overestimate my ability. I am singing off key and I have no clue.

**2. Conscious Incompetence.** Now I can perceive my ignorance, my lack of skill or knowledge. I know that what I'm doing takes more work to do effectively. I'm looking for a teacher. I am still singing off key, but I can hear it and I want to improve.

**3. Conscious Competence.** I'm getting good at this thing. I know how to do it, but have to focus on the basics. I'm making mistakes, but I'm learning from them. I know how to sing in tune. I know how to correct when I am a little bit off key.

**4. Unconscious Competence.** I'm doing it just fine and I've forgotten how. I sing in tune without thinking. I have no idea how I do it. I just sing.

So, you either can or you can't do the thing, and you're either aware or you're unaware of your ability.

You never know when you are the one who is unconsciously incompetent. Hint: it might be something you THINK you're good at.

As an amateur singer, I was encouraged that I had a good voice but that it needed training. The only thing I heard was that I had a good voice. I didn't know what they meant by training, so I ignored it. It wasn't until years later, when I had a teacher who recorded me (and made me listen), that I found out how far off key I really was.

The move from unconscious incompetence to conscious incompetence can be painful. Humiliating. It's hard to internalize that what you thought was a strength is, in fact, a glaring weakness. Self-delusion (denial) is a strong force.

The good news is that this new-found discovery is an opportunity for growth. It just takes humility to seek help, and a whole lot of willingness to do the work to get to the next stage.

Where are you on this scale? Is there something where you want to change categories?`,
}

export default post
